import template from './auto_scheduler.html';

/**
 * @class AutoSchedulerReportsDialogVM
 */
class AutoSchedulerDialogVM
{
	constructor (dialog)
	{
		this.dialog = dialog;

		/**
		* @memberof AutoSchedulerDialogVM
		* @alias active
		* @type {ObservableBoolean}
		*/
		this.active = ko.observable(true);

		/**
		 * Process name
		 * @alias process_name
		 * @memberof AutoSchedulerDialogVM
		 * @type {ObservableString}
		 */
		this.process_name = ko.observable('');
		/**
		 * Process id
		 * @alias process_id
		 * @memberof AutoSchedulerDialogVM
		 * @type {ObservableInteger}
		 */
		this.process_id = ko.observable(null);
		/**
		 * Existing Autoscheduler list
		 * @alias auto_schedulers
		 * @memberof AutoSchedulerDialogVM
		 * @type {ObservableArray}
		 */
		//this.auto_schedulers = ko.observableArray([]);

		/**
		 * Currently selected Auto scheduler
		 * @alias 
		 * @memberof AutoSchedulerDialogVM
		 * @type {ObservableInteger}
		 */
		this.auto_scheduler = ko.observable(null);
		this.auto_scheduler.subscribe( (auto_scheduler) => { this.load(auto_scheduler); });

		/**
		 * Currently selected Auto scheduler ID
		 * @alias autoscheduler_id
		 * @memberof AutoSchedulerDialogVM
		 * @type {ObservableInteger}
		 */
		this.auto_scheduler_id = ko.observable(null);
		
		/**
		 * This value can be used when the view is closed to
		 * determine if a refresh is needed. It is updated
		 * when a schedule is saved or deleted.
		 */
		this.exit_code = ko.observable(0);
		
		this.process = ko.observable({});

		// Autoscheduler options
		this.dow = ko.observable('0000000');
		this.dom = ko.observable('');
		this.day_time = ko.observable('00:00');
		this.scheduled_interval_hr = ko.observable('00');
		this.scheduled_interval_min = ko.observable('00');
		this.scheduled_interval_sec = ko.observable('00');

		// Array with boolean observables for day of month
		this.days_of_month = [];
		for (let i = 1; i < 32; i++)
			this.days_of_month[i] = ko.observable(false);
		this.dom.subscribe((x) => this.update_days_of_month());

		// Array with boolean observables for day of week
		this.days_of_week = [];
		for (let i = 0; i < 7; i++)
			this.days_of_week[i] = ko.observable(false);
		this.dow.subscribe((x) => this.update_days_of_week());

		this.weekday_names = ko.observableArray(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);

		this.scheduled_interval = ko.pureComputed(() => {
			return [
				this.scheduled_interval_hr(), 
				this.scheduled_interval_min(), 
				this.scheduled_interval_sec()
			].join(':');
		}, this);

		// helper 
		this.time_type = ko.observable('tod'); // can be tod or toi

		//this.params = ko.observable({});
		this.params_title = ko.observable('');
		this.params_fields = ko.observableArray([]);
		this.params_inputs = ko.observable({});

		//reports
		this.mode = ko.observable('create');

		this.report_definition_name = ko.observable('');

		this.available_groups = ko.observableArray('');
		this.selected_group = ko.observable('');
		this.selected_group.subscribe(() => this.get_report_definition());
		this.available_report_definitions = ko.observableArray([]);
		this.selected_report_definition = ko.observable();
		this.selected_report_definition.subscribe( (selected_report_definition) => this.report_selected(selected_report_definition));

		this.email_list = ko.observable(false);

		//this.selected_email_list = ko.observable();
		//this.available_email_lists = ko.observableArray([]);
		
		this.ui_fields = [];

		//Message Manager
		this.elist = [];
		this.list_namespace = ko.observableArray([]);
		this.selected_list_namespace = ko.observable();
		this.selected_list_namespace.subscribe( () => this.get_email_lists() );
		this.emailList = ko.observableArray([]);
		this.selectedEmailList = ko.observable('');

	}
	get_email_lists()
	{
		let name_list = this.elist.filter((item) => { return item.namespace == this.selected_list_namespace() });
		this.emailList(name_list);
	}
	// Replace lodash range
	range (start, end)
	{
		let result = [];
		for (let i = start; i < end; i++)
			result.push(i);
		return result;
	}
	
	load (auto_scheduler)
	{
		// Reset values
		this.time_type('tod');
		this.day_time('00:00');
		this.scheduled_interval_hr('0');
		this.scheduled_interval_min('0');
		this.scheduled_interval_sec('0');
		this.dom('');
		this.dow('0000000');

		if (!auto_scheduler || !auto_scheduler.auto_scheduler_id)
			return;

		this.auto_scheduler_id(auto_scheduler.auto_scheduler_id);
		this.active(auto_scheduler.active);
		this.selected_group(auto_scheduler.reports_auto_scheduler.group);
		
		if (auto_scheduler.run_with_params && auto_scheduler.run_with_params.email_list && (Object.keys(auto_scheduler.run_with_params.email_list).length > 0)){
			this.email_list(true);
			this.selected_list_namespace(auto_scheduler.run_with_params.email_list.namespace);
			for (const list of this.elist){
				if (list.namespace == auto_scheduler.run_with_params.email_list.namespace && list.name == auto_scheduler.run_with_params.email_list.name)
					this.selectedEmailList(list);
			}
		}

		if (auto_scheduler.day_time && auto_scheduler.day_time != '')
		{
			this.scheduled_interval_hr('0');
			this.scheduled_interval_min('0');
			this.scheduled_interval_sec('0');

			this.time_type('tod');

			if (auto_scheduler.day_time.length > 5)
				auto_scheduler.day_time = auto_scheduler.day_time.slice(0, -3);

			this.day_time(auto_scheduler.day_time);
		}
		else if (auto_scheduler.scheduled_interval && auto_scheduler.scheduled_interval != '')
		{
			this.day_time('');

			this.time_type('ti');

			let split = auto_scheduler.scheduled_interval.split(':');
			this.scheduled_interval_hr(split[0]);
			this.scheduled_interval_min(split[1]);
			this.scheduled_interval_sec(split[2]);
		}

		if (auto_scheduler.days_of_month && auto_scheduler.days_of_month != '')
			this.dom(auto_scheduler.days_of_month);

		if (auto_scheduler.dow && auto_scheduler.dow != '')
			this.dow(auto_scheduler.dow);
		
		if (auto_scheduler.run_with_params.ui_fields)
			this.ui_fields = auto_scheduler.run_with_params.ui_fields;

		if (Object.keys(this.ui_fields).length > 0)
		{
			let process_params = this.build_process_params(auto_scheduler.reports_auto_scheduler.ui_fields, auto_scheduler.run_with_params.report_function_criteria);

			for (const field of process_params)
				if (field.name == 'report_definition_id')
					field.default_value = auto_scheduler.run_with_params.report_definition_id;

			this.params_title('Schedule Parameters');
			this.params_fields(process_params);
		}
	}

	build_process_params (ui_fields, report_function_criteria){
		let process_params = ui_fields;
		process_params = process_params.map((field) => {field.default_value = ''; return field;});

		if (report_function_criteria && (Object.keys(report_function_criteria).length > 0)){
			for (let [key, value] of Object.entries(report_function_criteria)){
				for (const field of process_params){
					if (field.name == key){
						if (field.type == 'json')
							field.default_value = JSON.stringify(value);
						else
							field.default_value = value;
					}
				}
			}
		}
		return process_params;
	}

	/**
	 * Update days_of_month array after dom() has been updated
	 */
	update_days_of_month ()
	{
		let days = [];
		
		if (this.dom().length > 0)
			if (this.dom() == '*')
				for (let i = 1; i <= 31; i++)
					days.push(i);
			else
				days = this.dom().split(',').map((x) => parseInt(x));
				
		for (let i = 1; i < 32; i++){
			if (days.indexOf(i) > -1){
				this.days_of_month[i](true);
			}
		}
	}

	btnDOM_click (day)
	{
		this.days_of_month[day](!this.days_of_month[day]());
	}

	/**
	 * Update days_of_week array after dow() has been updated
	 */
	update_days_of_week ()
	{
		for (let i = 0; i < this.dow().length; i++)
		{
			if (this.dow()[i] === '1')
				this.days_of_week[i](true);
			else
				this.days_of_week[i](false);
		}
	}

	async btnSave_click ()
	{
		let request = {
			auto_scheduler_id: this.auto_scheduler_id(),
			process_id: this.process_id(),
			dow: '',
			days_of_month: '',
			active: this.active(),
			user_id: this.process.user_id,
			params: {}
		};

		// Get days of week
		for (let i = 0; i < this.days_of_week.length; i++)
			if (this.days_of_week[i]() === true)
				request.dow += '1';
			else
				request.dow += '0';

		let doms = [];
		// Get days of month
		for (let i = 1; i < 32; i++)
			if (this.days_of_month[i]() === true)
				doms.push(i);
		request.days_of_month = doms.join(',');

		// 'Time of day' or 'Interval'
		if (this.time_type() == 'tod')
			request.day_time = this.day_time();
		else 
			request.scheduled_interval = this.scheduled_interval();

		let params = {};
		params.ui_fields = this.params_fields();
		
		let report_function_criteria = {};
		// Get render-fields values
		if (this.params_fields().length > 0)
		{
			for (let [name, $input] of Object.entries(this.params_inputs())){
				for (const field of this.params_fields()){
					if (field.name == name){
						if (field.type == 'json')
							if (typeof (($input)()) === "object")
								report_function_criteria[name] = ($input)();
							else
								report_function_criteria[name] = JSON.parse(($input)());
						else
							report_function_criteria[name] = ($input)();
					}
				}
			}
		}
		params.report_function_criteria = report_function_criteria;
		
		// Get scheduled report and email;
		if (this.mode() === 'create')
			params.report_definition_id = this.selected_report_definition().report_definition_id;
		else
			params.report_definition_id = this.auto_scheduler().run_with_params.report_definition_id;

		if (this.email_list())
			params.email_list = this.selectedEmailList();
		
		request.params = params;

		//console.log(`Save request --> ${JSON.stringify(request)}`);

		let result = await Grape.fetches.postJSON(`/api/report/autoschedule/save`, request);

		if (result.status == 'ERROR')
		{
			Grape.alert_api_error(result);
			return;
		}

		this.exit_code(1);

		Grape.alerts.alert({
			type: 'success',
			title: 'AutoSchedule Report',
			message: 'Auto scheduler saved'
		});

		this.dialog.close(true);
	}

	//ToDo Delete for reports
	/**
	 * Event handler for delete button click
	 * @memberof AutoSchedulerDialog
	 */
	async btnDelete_click ()
	{
		if (!this.auto_scheduler_id())
			return;

		let accept = await Grape.alerts.confirm({type: 'warning', title: 'Confirm delete', message: 'Are you sure you want to delete this auto scheduler?'});
		if (!accept)
			return;
		
		const result = await Grape.fetches.fetch(
			`/api/bgworker/process/${this.process_id()}/autoscheduler/${this.auto_scheduler_id()}`,
			{
				method: 'DELETE'
			});

		Grape.alerts.alert({type: 'success', title: 'Deleted', message: 'Autoscheduler has been deleted'});
		
		this.exit_code(1);

		this.dialog.close(true);
	}

	//Reports
	async get_report_definition ()
	{
		let group_value = this.selected_group();

		let result = await Grape.fetches.getJSON('/api/report/definition/all', {
			'group': group_value, 
			'active': true
		});
		if (result.status !== 'ERROR')
			this.available_report_definitions(result.records);
		else
			Grape.alert_api_error(result);

		if (this.mode() == 'create')
			return;

		let scheduler = this.auto_scheduler();
		if (scheduler && (Object.keys(scheduler).length > 0)){
			for (const report_definition of this.available_report_definitions()){
				if (report_definition.group == scheduler.reports_auto_scheduler.group && report_definition.name == scheduler.reports_auto_scheduler.report_definition_name)
					this.selected_report_definition(report_definition);
			}
		}
	}

	report_selected(selected_report_definition){
		if (selected_report_definition.ui_fields)
			this.ui_fields = selected_report_definition.ui_fields;

		let auto_scheduler = this.auto_scheduler();
		let process_params = []
		if (this.ui_fields.length > 0){
			if (auto_scheduler.reports_auto_scheduler && auto_scheduler.run_with_params)
				process_params = this.build_process_params(auto_scheduler.reports_auto_scheduler.ui_fields, auto_scheduler.run_with_params.report_function_criteria);
			else
				process_params = this.build_process_params(selected_report_definition.ui_fields, selected_report_definition.default_function_criteria);

			this.params_title('Schedule Parameters');
		}else{
			this.params_title('');
		}

		this.params_fields(process_params);
	}

	async get_user_email_list ()
	{
		let params = {
			schema: 'messages',
			table: 'v_address_list',
			sortfield: 'address_list_id',
			limit: 5000
		};
		let name_space = new Set();

		let results = await Grape.fetches.getJSON("/api/record", params);
		if (results)
		{
			if (results.result_count == 0 || results.records == undefined)
				results.records = [];
				
			this.elist = results.records;

			for (const list of this.elist){
				name_space.add(list.namespace);
			}
		}
		this.list_namespace(Array.from(name_space));
	}

}

/**
 * @class AutoSchedulerDialog
 * @implements {GrapeDialogType}
 * @image autoschedulerdialog.png
 * @param {Object} bindings
 * @param {Object} bindings.autoscheduler
 * @param {Object} bindings.process
 * @param {Object} bindings.process
 * @param {String} bindings.process.process_name
 * @param {Integer} bindings.process.process_id
 * @param {Object[]} bindings.process.ui_params
 * @example
 * 
 * window.Grape.show_dialog('AutoSchedulerDialog', {process: {process_name: 'SampleProcess', process_id: 1, ui_param: {}, autoscheduler: []}});
 *
 */
class AutoSchedulerReportsDialog
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.process = bindings.process;
		this.autoscheduler = bindings.autoscheduler || null;

		/**
		 * @memberof AutoSchedulerDialog
		 * @name viewModel
		 * @type {AutoSchedulerDialogVM}
		 */
		this.viewModel = new AutoSchedulerDialogVM(this);
		this.viewModel.process = this.process;

		//reports
		this.viewModel.mode(this.bindings.mode);

		this.init();
	}

	/**
	 * Init function
	 * @memberof AutoSchedulerDialog
	 * @alias init
	 */
	async init () 
	{
		// reports Get report definition groups
		let result = await Grape.fetches.getJSON('/api/report/definition/groups', {'active': true});
		if (result.status === 'OK')
		{
			result.records.forEach((record) => {
				if(this.viewModel.available_groups.indexOf(record.group) == -1)
					this.viewModel.available_groups.push(record.group);
			});
		}

		// Message Manager
		await this.viewModel.get_user_email_list();

		this.viewModel.process_name(this.process.process_name);
		this.viewModel.process_id(this.process.process_id);

		if ((this.process.ui_param) && (this.process.ui_fields))
		{
			this.viewModel.params_fields(this.process.ui_param);
			this.viewModel.params_title('Schedule Parameters');
		}
		//this.viewModel.auto_schedulers(this.process.auto_schedulers || []);

		if (this.autoscheduler)
			this.viewModel.auto_scheduler(this.autoscheduler);
		
	}

	/**
	 * Event handler for close button
	 * @memberof AutoSchedulerDialog
	 * @alias btnclose_click
	 */
	btnClose_click ()
	{
		this.close(this.viewModel.exit_code());
	}
}

export default {
	name: 'AutoSchedulerReportsDialog',
	dialog_class: AutoSchedulerReportsDialog,
	template: template,
	provider: "ps"
}